import simplifiedGraphemesFrequencyJson from "#simplified-graphemes-frequency" with { type: "json" };
import graphemeFrequencyRanksJson from "#grapheme-frequency-ranks" with { type: "json" };
import traditionalGraphemesFrequencyJson from "#traditional-graphemes-frequency" with { type: "json" };

export type GraphemesFrequencyBucket = {
  /** Glyphs whose cumulative frequency falls inside [lowerPct, upperPct], in rank order. */
  characters: string[];
  /** Lower bound of the bucket's cumulative percentage range. */
  lowerPct: number;
  /** Cumulative top-of-text percentage threshold (e.g. 10, 20, …, 99.9). */
  threshold: number;
  /** Upper bound of the bucket's cumulative percentage range (= threshold). */
  upperPct: number;
};

export type GraphemesFrequencyData = {
  /** Buckets in ascending threshold order. */
  buckets: GraphemesFrequencyBucket[];
};

export const simplifiedGraphemesFrequency: GraphemesFrequencyData =
  simplifiedGraphemesFrequencyJson;
export const traditionalGraphemesFrequency: GraphemesFrequencyData =
  traditionalGraphemesFrequencyJson;

/**
 * Glyph → 1-based corpus frequency rank: `subtlex` from SUBTLEX-CH-CHR (simplified), `biau` from the
 * BIAU character list (traditional). A glyph absent from a map has no rank in that corpus.
 */
export type GraphemeFrequencyRanks = {
  biau: Readonly<Record<string, number>>;
  subtlex: Readonly<Record<string, number>>;
};

export const graphemeFrequencyRanks: GraphemeFrequencyRanks = graphemeFrequencyRanksJson;
